// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-scan__description {
  margin-bottom: 8px;
}
.document-scan__content {
  padding: 12px 16px 16px;
}
.document-scan__actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.document-scan__status {
  padding: 24px 16px;
  text-align: center;
}
.document-scan__status ion-icon {
  font-size: 40px;
  margin-bottom: 12px;
}
.document-scan__status ion-spinner {
  margin-bottom: 12px;
}
.document-scan__status h4 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
  color: var(--ion-color-dark);
}
.document-scan__status p {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--ion-color-medium);
}
.document-scan__status--processing ion-spinner {
  color: var(--ion-color-primary);
}
.document-scan__status--success ion-icon {
  color: var(--ion-color-success);
}
.document-scan__status--error ion-icon {
  color: var(--ion-color-danger);
}
.document-scan__error-message {
  font-size: 14px;
  line-height: 1.5;
  color: var(--ion-color-dark);
  margin: 0 0 16px;
}
.document-scan__success-message {
  font-size: 14px;
  line-height: 1.5;
  color: var(--ion-color-dark);
  margin: 0 0 16px;
}
.document-scan__editor {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.document-scan__preview {
  width: 100%;
  border-radius: 8px;
  object-fit: contain;
  max-height: 280px;
  background: var(--ion-color-light);
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.document-scan__preview:hover {
  opacity: 0.9;
}
.document-scan__field {
  margin-bottom: 14px;
}
.document-scan__field ion-item.item-input {
  --padding-start: 0px;
  --padding-end: 0px;
  --inner-padding-start: 0px;
  --inner-padding-end: 0px;
  margin-bottom: 1rem;
}
.document-scan__field ion-item.item-input ion-label {
  line-height: 1.2;
  justify-content: space-between;
  display: flex;
  margin: inherit;
  font-size: 1rem;
}
.document-scan__field ion-item.item-input ion-input {
  border: 1px solid var(--ion-color-light);
  border-radius: 5px;
  height: 2.3em;
  font-size: 1rem;
  --padding-end: 1rem;
  --padding-start: 1rem;
  margin-top: 5px;
}
.document-scan__field ion-item.item-textarea {
  padding-left: 0px;
}
.document-scan__field ion-item.item-textarea ion-label {
  line-height: 1.2;
}
.document-scan__field ion-item.item-textarea ion-textarea {
  border: 1px solid var(--ion-color-light);
  border-radius: 5px;
  min-height: 2.3em;
  padding: 2px 15px;
}
.document-scan__field-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
}
.document-scan__required-error {
  color: var(--ion-color-danger);
}
.document-scan__field-error {
  margin: 6px 0 0;
  color: var(--ion-color-danger);
  font-size: 12px;
}
.document-scan__form-actions {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.document-scan__table {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0;
}
.document-scan__table-empty {
  color: var(--ion-color-medium);
  font-size: 13px;
}
.document-scan__table-row {
  border: 1px solid var(--ion-color-light-shade);
  border-radius: 6px;
  overflow: hidden;
}
.document-scan__table-row-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 4px 2px 8px;
  background: var(--ion-color-light);
  border-bottom: 1px solid var(--ion-color-light-shade);
}
.document-scan__table-row-header ion-button {
  --padding-start: 4px;
  --padding-end: 4px;
  height: 28px;
}
.document-scan__table-row-index {
  font-size: 11px;
  font-weight: 600;
  color: var(--ion-color-medium);
}
.document-scan__table-cells {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  padding: 8px;
}
.document-scan__table-cell {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.document-scan__table-cell-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--ion-color-medium);
  text-transform: uppercase;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.document-scan__table-input {
  width: 100%;
  height: 30px;
  padding: 0 8px;
  font-size: 13px;
  border: 1px solid var(--ion-color-light-shade);
  border-radius: 4px;
  background: var(--ion-background-color, #fff);
  color: var(--ion-text-color);
  outline: none;
  box-sizing: border-box;
}
.document-scan__table-input:focus {
  border-color: var(--ion-color-primary);
}
.document-scan__table-input[type=number] {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/components/document-scan/document-scan.component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;AAAJ;AAGE;EACE,uBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAKE;EACE,kBAAA;EACA,kBAAA;AAHJ;AAME;EACE,eAAA;EACA,mBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AANJ;AASE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAPJ;AAUE;EACE,+BAAA;AARJ;AAWE;EACE,+BAAA;AATJ;AAYE;EACE,8BAAA;AAVJ;AAaE;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AAXJ;AAcE;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AAZJ;AAeE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;EACA,eAAA;EACA,6BAAA;AAdJ;AAgBI;EACE,YAAA;AAdN;AAkBE;EACE,mBAAA;AAhBJ;AAkBI;EACE,oBAAA;EACA,kBAAA;EACA,0BAAA;EACA,wBAAA;EACA,mBAAA;AAhBN;AAkBM;EACE,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAhBR;AAmBM;EACE,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAjBR;AAqBI;EACE,iBAAA;AAnBN;AAqBM;EACE,gBAAA;AAnBR;AAsBM;EACE,wCAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AApBR;AAyBE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,8BAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,8BAAA;EACA,eAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,yBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;AA3BJ;AA8BE;EACE,8BAAA;EACA,eAAA;AA5BJ;AA+BE;EACE,8CAAA;EACA,kBAAA;EACA,gBAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qDAAA;AA9BJ;AAgCI;EACE,oBAAA;EACA,kBAAA;EACA,YAAA;AA9BN;AAkCE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,YAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnCJ;AAsCE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,8CAAA;EACA,kBAAA;EACA,6CAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;AApCJ;AAsCI;EACE,sCAAA;AApCN;AAuCI;EACE,iBAAA;AArCN","sourcesContent":[".document-scan {\n  &__description {\n    margin-bottom: 8px;\n  }\n\n  &__content {\n    padding: 12px 16px 16px;\n  }\n\n  &__actions {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__status {\n    padding: 24px 16px;\n    text-align: center;\n  }\n\n  &__status ion-icon {\n    font-size: 40px;\n    margin-bottom: 12px;\n  }\n\n  &__status ion-spinner {\n    margin-bottom: 12px;\n  }\n\n  &__status h4 {\n    margin: 0 0 8px;\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--ion-color-dark);\n  }\n\n  &__status p {\n    margin: 0 0 16px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: var(--ion-color-medium);\n  }\n\n  &__status--processing ion-spinner {\n    color: var(--ion-color-primary);\n  }\n\n  &__status--success ion-icon {\n    color: var(--ion-color-success);\n  }\n\n  &__status--error ion-icon {\n    color: var(--ion-color-danger);\n  }\n\n  &__error-message {\n    font-size: 14px;\n    line-height: 1.5;\n    color: var(--ion-color-dark);\n    margin: 0 0 16px;\n  }\n\n  &__success-message {\n    font-size: 14px;\n    line-height: 1.5;\n    color: var(--ion-color-dark);\n    margin: 0 0 16px;\n  }\n\n  &__editor {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__preview {\n    width: 100%;\n    border-radius: 8px;\n    object-fit: contain;\n    max-height: 280px;\n    background: var(--ion-color-light);\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n\n    &:hover {\n      opacity: 0.9;\n    }\n  }\n\n  &__field {\n    margin-bottom: 14px;\n\n    ion-item.item-input {\n      --padding-start: 0px;\n      --padding-end: 0px;\n      --inner-padding-start: 0px;\n      --inner-padding-end: 0px;\n      margin-bottom: 1rem;\n\n      ion-label {\n        line-height: 1.2;\n        justify-content: space-between;\n        display: flex;\n        margin: inherit;\n        font-size: 1rem;\n      }\n\n      ion-input {\n        border: 1px solid var(--ion-color-light);\n        border-radius: 5px;\n        height: 2.3em;\n        font-size: 1rem;\n        --padding-end: 1rem;\n        --padding-start: 1rem;\n        margin-top: 5px;\n      }\n    }\n\n    ion-item.item-textarea {\n      padding-left: 0px;\n\n      ion-label {\n        line-height: 1.2;\n      }\n\n      ion-textarea {\n        border: 1px solid var(--ion-color-light);\n        border-radius: 5px;\n        min-height: 2.3em;\n        padding: 2px 15px;\n      }\n    }\n  }\n\n  &__field-label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n  }\n\n  &__required-error {\n    color: var(--ion-color-danger);\n  }\n\n  &__field-error {\n    margin: 6px 0 0;\n    color: var(--ion-color-danger);\n    font-size: 12px;\n  }\n\n  &__form-actions {\n    margin-top: 16px;\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n  }\n\n  &__table {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin: 4px 0;\n  }\n\n  &__table-empty {\n    color: var(--ion-color-medium);\n    font-size: 13px;\n  }\n\n  &__table-row {\n    border: 1px solid var(--ion-color-light-shade);\n    border-radius: 6px;\n    overflow: hidden;\n  }\n\n  &__table-row-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 2px 4px 2px 8px;\n    background: var(--ion-color-light);\n    border-bottom: 1px solid var(--ion-color-light-shade);\n\n    ion-button {\n      --padding-start: 4px;\n      --padding-end: 4px;\n      height: 28px;\n    }\n  }\n\n  &__table-row-index {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--ion-color-medium);\n  }\n\n  &__table-cells {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 6px;\n    padding: 8px;\n  }\n\n  &__table-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  &__table-cell-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--ion-color-medium);\n    text-transform: uppercase;\n    letter-spacing: 0.2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__table-input {\n    width: 100%;\n    height: 30px;\n    padding: 0 8px;\n    font-size: 13px;\n    border: 1px solid var(--ion-color-light-shade);\n    border-radius: 4px;\n    background: var(--ion-background-color, #fff);\n    color: var(--ion-text-color);\n    outline: none;\n    box-sizing: border-box;\n\n    &:focus {\n      border-color: var(--ion-color-primary);\n    }\n\n    &[type='number'] {\n      text-align: right;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
